package kz.dentalcrm.app.screens.diagnosis.list

import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis
import kz.dentalcrm.app.domain.DiagnosisRepository
import kz.dentalcrm.app.screens.diagnosis.list.mvi.DiagnosisViewEvent
import kz.dentalcrm.app.screens.diagnosis.list.mvi.DiagnosisViewSideEffect
import kz.dentalcrm.app.screens.diagnosis.list.mvi.DiagnosisViewState
import org.koin.core.component.inject

class DiagnosisViewModel :
    BaseStateViewModel<DiagnosisViewEvent, DiagnosisViewState, DiagnosisViewSideEffect>() {

    private val diagnosisRepository: DiagnosisRepository by inject()

    override fun setInitialState() = DiagnosisViewState()

    private var currentPage: Int = 1
    private var _isLastPage: Boolean = false

    private val serviceList = mutableListOf<Diagnosis>()

    override fun handleEvents(event: DiagnosisViewEvent) {
        when (event) {
            is DiagnosisViewEvent.SearchService -> {
                _isLastPage = false
                currentPage = 1
                serviceList.clear()
                setState {
                    copy(
                        search = event.search,
                        diagnosis = persistentListOf()
                    )
                }
                loadServices(
                    delayMillis = 300L
                )
            }
            DiagnosisViewEvent.LoadMore -> {
                loadServices()
            }
            DiagnosisViewEvent.Reload -> {
                _isLastPage = false
                currentPage = 1
                serviceList.clear()
                setState {
                    copy(
                        diagnosis = persistentListOf()
                    )
                }
                loadServices(delayMillis = 1500L)
            }
            DiagnosisViewEvent.AddServiceCategory -> {

            }
            is DiagnosisViewEvent.EditService -> {
                setEffect {
                    DiagnosisViewSideEffect.ShowEditService(
                        service = event.service
                    )
                }
            }
            is DiagnosisViewEvent.DeleteDiagnosis -> {
                serviceList.removeAll { it.id == event.id }
                setState {
                    copy(diagnosis = serviceList.toPersistentList())
                }
            }
        }
    }

    private fun loadServices(
        delayMillis: Long = 0L
    ) {
        if (_isLastPage) {
            return
        }
        setState {
            copy(
                screenState = DiagnosisViewState.ScreenState.Loading
            )
        }
        launch(Dispatchers.Default) {
            delay(delayMillis)
            diagnosisRepository.getDiagnosis(
                search = viewState.value.search,
                pageSize = PAGE_SIZE,
                page = currentPage
            ).stateHandle(
                onError = { _, message ->
                    setState {
                        copy(
                            screenState = DiagnosisViewState.ScreenState.Error(
                                text = message
                            )
                        )
                    }
                },
                onFailure = {
                    setState {
                        copy(
                            screenState = DiagnosisViewState.ScreenState.Error(
                                text = "Произошла неожиданная ошибка"
                            )
                        )
                    }
                },
                onSuccess = { data ->
                    serviceList.addAll(data?.data ?: emptyList())
                    currentPage++
                    setState {
                        copy(
                            diagnosis = serviceList.toPersistentList(),
                            screenState = DiagnosisViewState.ScreenState.Idle
                        )
                    }
                    _isLastPage = (data?.data?.size ?: 0) < PAGE_SIZE
                }
            )
        }
    }

    init {
        loadServices()
    }

    companion object {
        private const val PAGE_SIZE = 10
    }
}